import cx from 'clsx';
import { type ReactElement } from 'react';
import { TextField, PeriodPickerField } from '@ff-it/form';

export function LinkerFields({ className }: { className?: string }): ReactElement {
  return (
    <div className={cx('form-row', className)}>
      <PeriodPickerField
        name="finance_period"
        placeholder="Finance period"
        className="col-md-4 mb-0"
        part="month"
        size="sm"
      />
      <TextField
        name="link_notes"
        placeholder="Link notes for internal use. Wont be visible in invoice."
        className="col-md-8"
        size="sm"
        multiline
      />
    </div>
  );
}
